/**
 * @fileoverview Barrel exports for the continuity-extractor-v2 agent.
 */

export { definition } from './definition';

export {
  InputSchema,
  OutputSchema,
  ProposedContinuityFactSchema,
  ProposedResolutionSchema,
  type Input,
  type Output,
  type ProposedContinuityFact,
  type ProposedResolution,
} from './schema';

export { flow, continuityExtractorV2AgentFlow } from './flow';

export { prompt } from './prompt';
